import axios from "axios";
import { withView, ppapiPost, WALLETLESS_URL } from "../../utils/partnerApi";

export const LOADING_STATE = "LOADING_STATE";
export const CUSTOM_LOADER = "CUSTOM_LOADER";

export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const AUTHENTICATED_USER = "AUTHENTICATED_USER";
export const UPDATE_BPS = "[USER] UPDATE_BPS";
export const UPDATE_ACCOUNT_TYPE = "[USER] UPDATE_ACCOUNT_TYPE";

export const AVAILABLE_PERMISSIONS = "[USER] AVAILABLE_PERMISSIONS";
export const GET_VOLUMES = "[USER] GET_VOLUMES";
export const GET_TRANSACTIONS_CHART_DATA = "[USER] GET_TRANSACTIONS_CHART_DATA";
export const GET_PARTNER_DISCOUNT = "[USER] GET_PARTNER_DISCOUNT";
export const API_REQUEST_LIMITS = "[USER] API_REQUEST_LIMITS";
export const GET_USER_TRANSACTIONS = "[USER] GET_USER_TRANSACTIONS";
export const GET_USER_WITHDRAW_HISTORY = "[USER] GET_USER_WITHDRAW_HISTORY";
export const GET_ACTIVE_WALLET = "[USER] GET_ACTIVE_WALLET";
export const CHANGE_WALLET = "[USER] CHANGE_WALLET";
export const WITHDRAW_FEES = "[USER] WITHDRAW_FEES";
export const UPDATE_CLIENT_EMAIL = "[USER] UPDATE_CLIENT_EMAIL";

export const AVAILABLE_CHAINS = "AVAILABLE_CHAINS";
export const AVAILABLE_CURRENCIES = "AVAILABLE_CURRENCIES";

export const CHANGE_PAGE = "CHANGE_PAGE";

export const CHANGE_ERROR_MESSAGE = "[FORM] CHANGE ERROR MESSAGE";

export const AUTH_LOADING = "AUTH_LOADING";

export const GET_WHITELISTED_IPS = "[USER] GET_WHITELISTED_IPS";
export const ADD_WHITELISTED_IP = "[USER] ADD_WHITELISTED_IP";
export const DELETE_WHITELISTED_IP = "[USER] DELETE_WHITELISTED_IP";
export const CHANGE_PASSWORD_SUCCESS = "[USER] CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PUBLIC_NAME_SUCCESS = "[USER] CHANGE_PUBLIC_NAME_SUCCESS";
export const CHANGE_PUBLIC_NAME_ERROR = "[USER] CHANGE_PUBLIC_NAME_ERROR";

export const GET_WHITELISTED_WEBSITES = "[USER] GET_WHITELISTED_WEBSITES";
export const ADD_WHITELISTED_WEBSITE = "[USER] ADD_WHITELISTED_WEBSITE";
export const DELETE_WHITELISTED_WEBSITE = "[USER] DELETE_WHITELISTED_WEBSITE";

export const GET_WEBHOOK_CONFIG = "[USER] GET_WEBHOOK_CONFIG";
export const SAVE_WEBHOOK_CONFIG = "[USER] SAVE_WEBHOOK_CONFIG";

export const GET_QUOTES = "[USER] GET_QUOTES";

export const GET_OWN_WALLET_AUDIT = "[USER] GET_OWN_WALLET_AUDIT";
export const GET_OWN_WALLET_AUDIT_LOADING = "[USER] GET_OWN_WALLET_AUDIT_LOADING";
export const UPDATE_PARTNER_WALLET_SUCCESS = "[USER] UPDATE_PARTNER_WALLET_SUCCESS";

export const LIST_PARTNER_WALLETS = "[USER] LIST_PARTNER_WALLETS";
export const LIST_PARTNER_WALLETS_LOADING = "[USER] LIST_PARTNER_WALLETS_LOADING";
export const FIND_UNLINKED_WALLETS = "[USER] FIND_UNLINKED_WALLETS";
export const FIND_UNLINKED_WALLETS_LOADING = "[USER] FIND_UNLINKED_WALLETS_LOADING";

export const GET_SUB_FEES = "[USER] GET_SUB_FEES";
export const GET_SUB_FEES_LOADING = "[USER] GET_SUB_FEES_LOADING";
export const CREATE_SUB_FEE = "[USER] CREATE_SUB_FEE";
export const UPDATE_SUB_FEE = "[USER] UPDATE_SUB_FEE";
export const DELETE_SUB_FEE = "[USER] DELETE_SUB_FEE";
export const GET_SUB_AFFILIATE_FEES = "[USER] GET_SUB_AFFILIATE_FEES";
export const GET_SUB_AFFILIATE_FEES_LOADING = "[USER] GET_SUB_AFFILIATE_FEES_LOADING";

export const TWO_FACTOR_STATUS = "[USER] TWO_FACTOR_STATUS";
export const TWO_FACTOR_LOADING = "[USER] TWO_FACTOR_LOADING";

export const handleAuthLoading = (status) => ({
  type: AUTH_LOADING,
  payload: status,
});

export function loginUser(email, password) {
  return (dispatch) => {
    dispatch(handleLoadState(true));
    const currentUrl = window.location.href;
    let payload = {
      login: "",
      username: email,
      urlUsed: currentUrl,
      password,
    };

    const request = axios.post(
      `https://ppapi.instaswap.com/formData`,
      payload
    );

    request
      .then((response) => {
        dispatch({
          type: LOGIN_USER,
          payload: response.data,
        });

        localStorage.setItem("hash", response.data.response.hash);
        localStorage.setItem("username", response.data.response.email);
        localStorage.setItem("expirationTime", new Date().getTime() + 86400000);
        localStorage.setItem("affiliateId", response.data.response.affiliateId);
        dispatch(handleLoadState(false));
      })
      .catch((error) => {
        dispatch(handleLoadState(false));
        if (error.response && error.response.data) {
          if (error.response.data.response === "Incorect Hash") {
            dispatch({
              type: CHANGE_ERROR_MESSAGE,
              payload: "Your session has expired",
            });
            dispatch({
              type: CHANGE_ERROR_MESSAGE,
              payload: "",
            });
            // Drop the stale session keys so the login modal can open again.
            localStorage.removeItem("hash");
            localStorage.removeItem("username");
            localStorage.removeItem("expirationTime");
            localStorage.removeItem("affiliateId");
            dispatch(logout());
          } else {
            dispatch({
              type: CHANGE_ERROR_MESSAGE,
              payload: error.response.data.response,
            });
          }
        }
      });
  };
}

export function autoLoginUser(ssid) {
  return (dispatch) => {
    dispatch(handleLoadState(true));
    let payload = {
      autoLogin: "",
      ssid: ssid
    };
    const request = axios.post(
      `https://ppapi.instaswap.com/formData`,
      payload
    );

    request
      .then((response) => {
        dispatch({
          type: LOGIN_USER,
          payload: response.data,
        });

        localStorage.setItem("hash", response.data.response.hash);
        localStorage.setItem("username", response.data.response.email);
        localStorage.setItem("expirationTime", new Date().getTime() + 86400000);
        localStorage.setItem("affiliateId", response.data.response.affiliateId);
        dispatch(handleLoadState(false));
      })
      .catch((error) => {
        dispatch(handleLoadState(false));
        if (error.response && error.response.data) {
          if (error.response.data.response === "Incorect Hash") {
            dispatch({
              type: CHANGE_ERROR_MESSAGE,
              payload: "Your session has expired",
            });
            dispatch({
              type: CHANGE_ERROR_MESSAGE,
              payload: "",
            });
            // Drop the stale session keys so the login modal can open again.
            localStorage.removeItem("hash");
            localStorage.removeItem("username");
            localStorage.removeItem("expirationTime");
            localStorage.removeItem("affiliateId");
            dispatch(logout());
          } else {
            dispatch({
              type: CHANGE_ERROR_MESSAGE,
              payload: error.response.data.response,
            });
          }
        }
      });
  };
}

// Admin impersonation: an admin opens /admin-login?ssid=... and is logged in
// AS the partner. Mirrors the autoLogin storage exactly so the rest of the app
// treats it like a normal partner session. The response additionally carries
// `impersonated: true` and `impersonatedBy` which the UI surfaces as a banner.
export function adminAutoLoginUser(ssid) {
  return (dispatch) => {
    dispatch(handleLoadState(true));
    let payload = {
      adminAutoLogin: true,
      ssid: ssid,
    };
    return axios
      .post(`https://ppapi.instaswap.com/formData`, payload)
      .then((response) => {
        dispatch({
          type: LOGIN_USER,
          payload: response.data,
        });

        // Mark this as an impersonation session so useReownAuth stays fully
        // inert (no auto-login/link/switch from the admin's own wallet).
        localStorage.setItem("impersonation", "true");
        localStorage.setItem("hash", response.data.response.hash);
        localStorage.setItem("username", response.data.response.email);
        localStorage.setItem("expirationTime", new Date().getTime() + 86400000);
        localStorage.setItem("affiliateId", response.data.response.affiliateId);
        dispatch(handleLoadState(false));
        return response.data.response;
      })
      .catch((error) => {
        dispatch(handleLoadState(false));
        const msg =
          error?.response?.data?.response ||
          "This impersonation link is invalid or has expired.";
        dispatch({ type: CHANGE_ERROR_MESSAGE, payload: msg });
        dispatch({ type: CHANGE_ERROR_MESSAGE, payload: "" });
        throw new Error(msg);
      });
  };
}

export const logout = () => ({
  type: LOGOUT_USER,
});

export function changePassword(
  currentPassword,
  newPassword,
  repeatNewPassword
) {
  return (dispatch) => {
    let hashToken = localStorage.getItem("hash");

    const currentUrl = window.location.href;


    let payload = {
      changePassword: "",
      urlUsed: currentUrl,
      oldPassword: currentPassword,
      newPassword,
      repeatNewPassword,
      hash: hashToken,
    };

    const request = axios.post(
      `https://ppapi.instaswap.com/formData`,
      payload
    );

    request
      .then((response) => {
        dispatch({ type: CHANGE_PASSWORD_SUCCESS, payload: response.data });
        dispatch(handleLoadState(false));
      })

      .catch((error) => {
        dispatch(handleLoadState(false));
        if (error.response.data) {
          dispatch({
            type: CHANGE_ERROR_MESSAGE,
            payload: error.response.data.response,
          });
        }
      });
  };
}

export function changePublicName(newPublicName) {
  return (dispatch) => {
    dispatch(handleLoadState(true));
    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      changePublicName: "",
      urlUsed: currentUrl,
      name: newPublicName,
      hash: hashToken,
    };

    return axios.post(
      `https://ppapi.instaswap.com/formData`,
      payload
    )
      .then((response) => {
        dispatch({ type: CHANGE_PUBLIC_NAME_SUCCESS, payload: { response: response.data, newPublicName } });
        dispatch(handleLoadState(false));
        // Refresh user data to ensure UI is updated everywhere
        const username = localStorage.getItem("username");
        if (username && hashToken) {
          dispatch(authenticateUser(hashToken, username));
        }
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        dispatch(handleLoadState(false));
        if (error.response?.data) {
          dispatch({
            type: CHANGE_PUBLIC_NAME_ERROR,
            payload: error.response.data.response,
          });
        }
        return Promise.reject(error.response?.data?.response || "Failed to update public name");
      });
  };
}

export function resetPassword(email) {
  return (dispatch) => {

    const currentUrl = window.location.href;


    let payload = {
      forgotPassword: "",
      urlUsed: currentUrl,
      username: email,
    };

    const request = axios.post(
      `https://ppapi.instaswap.com/formData`,
      payload
    );

    request
      .then(() => { })
      .catch((error) => {
        if (error.response.data) {
          dispatch({
            type: CHANGE_ERROR_MESSAGE,
            payload: error.response.data.response,
          });
        }
      });
  };
}

export const handleCustomLoader = (status) => ({
  type: CUSTOM_LOADER,
  payload: status,
});

export const handleLoadState = (status) => ({
  type: LOADING_STATE,
  payload: status,
});

export function getAvailablePermissions() {
  return (dispatch) => {
    dispatch(handleLoadState(true));
    let hashToken = localStorage.getItem("hash");

    const currentUrl = window.location.href;


    let payload = {
      availablePermissions: "",
      urlUsed: currentUrl,
      hash: hashToken,
    };

    const request = axios.post(
      "https://ppapi.instaswap.com/formData",
      payload
    );
    request
      .then((response) => {
        dispatch({
          type: AVAILABLE_PERMISSIONS,
          payload: response.data.response,
        });
        dispatch(handleLoadState(false));
      })
      .catch((error) => {
        dispatch(handleLoadState(false));
      });
  };
}



export function getWhitelistedIps() {
  return (dispatch) => {
    dispatch(handleLoadState(true));
    let hashToken = localStorage.getItem('hash');
    const currentUrl = window.location.href;

    let payload = {
      whitelistedIps: '',
      urlUsed: currentUrl,
      hash: hashToken,
    };

    return axios
      .post('https://ppapi.instaswap.com/formData', payload)
      .then((response) => {
        dispatch({
          type: GET_WHITELISTED_IPS,
          payload: response.data.response,
        });
      })
      .catch((error) => {
        console.error('Error fetching whitelisted IPs:', error);
      })
      .finally(() => {
        dispatch(handleLoadState(false));
      });
  };
}

export function addWhitelistedIp(ip) {
  return (dispatch) => {
    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      addWhitelistedIp: "",
      urlUsed: currentUrl,
      ip: ip,
      hash: hashToken,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then(() => {
        dispatch({
          type: ADD_WHITELISTED_IP,
          payload: ip,
        });
      })
      .catch((error) => {
        console.error('Error adding whitelisted IP:', error);
        throw error;
      })
      .finally(() => {
      });
  };
}

export function deleteWhitelistedIp(ip) {
  return (dispatch) => {
    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      deleteWhitelistedIp: "",
      urlUsed: currentUrl,
      ip: ip,
      hash: hashToken,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then(() => {
        dispatch({
          type: DELETE_WHITELISTED_IP,
          payload: ip,
        });
      })
      .catch((error) => {
        console.error('Error deleting whitelisted IP:', error);
        throw error;
      })
      .finally(() => {
      });
  };
}

export function getWhitelistedWebsites() {
  return (dispatch) => {
    dispatch(handleLoadState(true));
    let hashToken = localStorage.getItem('hash');
    const currentUrl = window.location.href;

    let payload = {
      whitelistedWebsites: '',
      urlUsed: currentUrl,
      hash: hashToken,
    };

    return axios
      .post('https://ppapi.instaswap.com/formData', payload)
      .then((response) => {
        dispatch({
          type: GET_WHITELISTED_WEBSITES,
          payload: response.data.response,
        });
      })
      .catch((error) => {
        console.error('Error fetching whitelisted websites:', error);
      })
      .finally(() => {
        dispatch(handleLoadState(false));
      });
  };
}

export function addWhitelistedWebsite(url) {
  return (dispatch) => {
    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      addWhitelistedWebsite: "",
      urlUsed: currentUrl,
      url: url,
      hash: hashToken,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then(() => {
        dispatch({
          type: ADD_WHITELISTED_WEBSITE,
          payload: url,
        });
      })
      .catch((error) => {
        console.error('Error adding whitelisted website:', error);
        throw error;
      })
      .finally(() => {
      });
  };
}

export function deleteWhitelistedWebsite(url) {
  return (dispatch) => {
    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      deleteWhitelistedWebsite: "",
      urlUsed: currentUrl,
      url: url,
      hash: hashToken,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then(() => {
        dispatch({
          type: DELETE_WHITELISTED_WEBSITE,
          payload: url,
        });
      })
      .catch((error) => {
        console.error('Error deleting whitelisted website:', error);
        throw error;
      })
      .finally(() => {
      });
  };
}

export function getAvailableChains() {
  return (dispatch) => {
    dispatch(handleLoadState(true));

    const request = axios.get(
      "https://api.instaswap.com/v1/full/universal/chainsDetails",
    );
    request
      .then((response) => {
        dispatch({
          type: AVAILABLE_CHAINS,
          payload: response.data.response,
        });
        dispatch(handleLoadState(false));
      })
      .catch((error) => {
        dispatch(handleLoadState(false));
      });
  };
}

export function getAvailableCurrencies() {
  return (dispatch) => {
    dispatch(handleLoadState(true));

    const request = axios.get(
      "https://api.instaswap.com/v1/full/universal/currencies-cached",
    );
    request
      .then((response) => {
        dispatch({
          type: AVAILABLE_CURRENCIES,
          payload: response.data.response.response,
        });
        dispatch(handleLoadState(false));
      })
      .catch((error) => {
        dispatch(handleLoadState(false));

      });
  };
}

export function getVolumes() {
  return (dispatch) => {
    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = withView({
      balances: "",
      urlUsed: currentUrl,
      hash: hashToken,
    });

    const request = axios.post(
      "https://ppapi.instaswap.com/formData",
      payload
    );
    request
      .then((response) => {
        dispatch({
          type: GET_VOLUMES,
          payload: response.data.response,
        });
      })
      .catch((error) => {
        // Error handled
      });
  };
}

export function apiRequestLimits() {
  return (dispatch) => {
    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      urlUsed: currentUrl,
      hash: hashToken,
    };

    const request = axios.post(
      "https://ppapi.instaswap.com/formData",
      payload
    );
    request
      .then((response) => {
        dispatch({
          type: API_REQUEST_LIMITS,
          payload: response.data.response,
        });
      })
      .catch((error) => {
        // Error handled
      });
  };
}

// `filters` (optional): { product: 'swap'|'split'|'payment'|'spot'|'perps',
// campaign: <code> | 'direct', from, to } — KOL_CAMPAIGNS_AGENCY_PLAN.md §4/§5.
export function getTransactions(item, per_page, filters = {}) {
  return (dispatch) => {
    if (item) {
      dispatch(handleCustomLoader(true));
    } else {
      dispatch(handleLoadState(true));
    }

    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = withView({
      transactions: "",
      urlUsed: currentUrl,
      page: item ? item : 1,
      itemsPerPage: per_page ? per_page : 5,
      hash: hashToken,
    });
    if (filters?.product) payload.product = filters.product;
    if (filters?.campaign) payload.campaign = filters.campaign;
    if (filters?.from) payload.from = filters.from;
    if (filters?.to) payload.to = filters.to;

    const request = axios.post(
      "https://ppapi.instaswap.com/formData",
      payload
    );
    request
      .then((response) => {
        dispatch({
          type: GET_USER_TRANSACTIONS,
          payload: response.data.response,
        });
        dispatch(handleCustomLoader(false));
        dispatch(handleLoadState(false));
      })
      .catch((error) => {
        dispatch(handleCustomLoader(false));
        dispatch(handleLoadState(false));
      });
  };
}

export function getTransactionsChartData(monthsBefore = 0) {
  return (dispatch) => {
    return new Promise((resolve, reject) => { // Return a promise
      let hashToken = localStorage.getItem("hash");
      const currentUrl = window.location.href;

      let payload = withView({
        transactionsGraph: "",
        urlUsed: currentUrl,
        hash: hashToken,
        monthsBefore: monthsBefore, // added monthsBefore
      });

      const request = axios.post(
        "https://ppapi.instaswap.com/formData",
        payload
      );
      request
        .then((response) => {
          dispatch({
            type: GET_TRANSACTIONS_CHART_DATA,
            payload: response.data.response,
          });
          resolve({ status: 200 }); // Resolve with a success status
        })
        .catch((error) => {
          reject(error); // Reject the promise on error
        });
    });
  };
}

// Partner volume discount tier + rolling volumes (PARTNER_VOLUME_DISCOUNT_PLAN.md).
// ppapi returns response.data.response = { currentTier, discountPct, volume30dUsd,
// volumes:{daily,monthly,allTime}, tiers:[{order,minVolumeUsd,discountPct}], graceUntil }.
export function getPartnerDiscount() {
  return (dispatch) => {
    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;
    const payload = withView({ discountTier: "", urlUsed: currentUrl, hash: hashToken });
    axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => {
        dispatch({
          type: GET_PARTNER_DISCOUNT,
          payload: response.data.response,
        });
      })
      .catch(() => {
        // non-fatal: dashboard renders without the discount card
      });
  };
}

// Access level self-service (KOL_CAMPAIGNS_AGENCY_PLAN.md §7.3 B): partner, kol and
// agency can each switch to any other mode (ppapi setAccountType).
export function setAccountType(accountType) {
  return async (dispatch) => {
    const data = await ppapiPost("setAccountType", { accountType });
    // Preferred: ppapi echoes { accountType }. Otherwise accept an explicit
    // success flag and re-read the level from isLogin (the login payload).
    if (data && typeof data.accountType === "string") {
      dispatch({ type: UPDATE_ACCOUNT_TYPE, payload: data.accountType.toLowerCase() });
      return data;
    }
    const okFlag = data === true || data?.success === true || data?.ok === true || data?.updated === true;
    if (!okFlag) throw new Error("Account modes are not enabled yet on this dashboard.");
    const fresh = await axios.post("https://ppapi.instaswap.com/formData", {
      isLogin: "", hash: localStorage.getItem("hash"), username: localStorage.getItem("username"), urlUsed: window.location.href,
    });
    const level = fresh.data?.response?.accountType;
    if (typeof level !== "string") throw new Error("Saved, but the dashboard could not read the new mode — please sign out and back in.");
    dispatch({ type: AUTHENTICATED_USER, payload: fresh.data });
    return { accountType: level };
  };
}

export function getWithdrawHistory(item) {
  return (dispatch) => {
    if (item) {
      dispatch(handleCustomLoader(true));
    } else {
      dispatch(handleLoadState(true));
    }

    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      withdrawHistory: "",
      urlUsed: currentUrl,
      hash: hashToken,
    };

    const request = axios.post(
      "https://ppapi.instaswap.com/formData",
      payload
    );
    request
      .then((response) => {
        dispatch({
          type: GET_USER_WITHDRAW_HISTORY,
          payload: response.data.response,
        });
        dispatch(handleCustomLoader(false));
        dispatch(handleLoadState(false));
      })
      .catch((error) => {
        dispatch(handleCustomLoader(false));
        dispatch(handleLoadState(false));
      });
  };
}

export function getActiveWallet(item) {
  return (dispatch) => {
    if (item) {
      dispatch(handleCustomLoader(true));
    } else {
      dispatch(handleLoadState(true));
    }

    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      gatherWithdrawWallet: "",
      urlUsed: currentUrl,
      hash: hashToken,
    };

    const request = axios.post(
      "https://ppapi.instaswap.com/formData",
      payload
    );
    request
      .then((response) => {
        dispatch({
          type: GET_ACTIVE_WALLET,
          payload: response.data.response,
        });
        dispatch(handleCustomLoader(false));
        dispatch(handleLoadState(false));
      })
      .catch((error) => {
        dispatch(handleCustomLoader(false));
        dispatch(handleLoadState(false));
      });
  };
}

export function changeWallet(wallet, twoFactorCode) {
  return (dispatch) => {
    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      saveWithdrawWallet: "",
      hash: hashToken,
      urlUsed: currentUrl,
      wallet,
      twoFactorCode,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => {
        // Re-fetch the saved wallet so the UI reflects the real stored value
        // instead of the save-response message string.
        dispatch(getActiveWallet(true));
        return response.data.response;
      })
      .catch((error) => {
        const backendMsg =
          error?.response?.data?.response ||
          error?.response?.data?.error ||
          error?.message;
        const err = new Error(backendMsg || "Failed to update wallet");
        err.status = error?.response?.status;
        throw err;
      });
  };
}

export function withdrawFees(amount, twoFactorCode) {
  return async (dispatch) => {
    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      withdrawRequest: "",
      urlUsed: currentUrl,
      hash: hashToken,
      amount: amount,
      twoFactorCode,
    };

    try {
      const response = await axios.post(
        "https://ppapi.instaswap.com/formData",
        payload
      );
      dispatch({
        type: WITHDRAW_FEES,
        payload: response.data.response,
      });
      setTimeout(() => {
        dispatch({
          type: WITHDRAW_FEES,
          payload: "",
        });
      }, 10000);
      return response.data.response; // Return the response
    } catch (error) {
      const backendMsg =
        error?.response?.data?.response ||
        error?.response?.data?.error ||
        error?.message;
      const err = new Error(backendMsg || "Failed to request withdrawal");
      err.status = error?.response?.status;
      throw err;
    }
  };
}

export function changePage(payload) {
  return (dispatch) => {
    const lastPage = localStorage.getItem("lastPage");
    if (lastPage) {
      localStorage.setItem("lastPage", payload);
    } else {
      localStorage.setItem("lastPage", payload);
    }

    dispatch({
      type: CHANGE_PAGE,
      payload: payload,
    });
  };
}

export function authenticateUser(hash, username, options = {}) {
  const { silent = false } = options;
  return (dispatch) => {
    const currentUrl = window.location.href;

    let payload = {
      username: username,
      hash: hash,
      urlUsed: currentUrl,
      isLogin: "",
    };
    // Silent revalidation (background polling) must not flip the whole app to
    // the auth loader; only the explicit on-mount call shows the loader.
    if (!silent) {
      dispatch(handleAuthLoading(true));
    }
    const request = axios.post(
      "https://ppapi.instaswap.com/formData",
      payload
    );
    request
      .then((response) => {
        dispatch({
          type: AUTHENTICATED_USER,
          payload: response.data,
        });
        // Keep persisting the latest hash on every call. The backend slides the
        // hash (it changes at most ~every 30 min) and the same account may be
        // logged in from multiple places at once, so a changed/unchanged hash
        // is NEVER a reason to force a re-login or logout.
        localStorage.setItem("hash", response.data.response.hash);
        localStorage.setItem("username", response.data.response.email);
        localStorage.setItem("affiliateId", response.data.response.affiliateId);
        // Slide the local 24h session window forward on each successful check.
        localStorage.setItem("expirationTime", new Date().getTime() + 86400000);
        if (!silent) {
          dispatch(handleAuthLoading(false));
        }
      })
      .catch((error) => {
        if (!silent) {
          dispatch(handleAuthLoading(false));
        }
        // Only a hard HTTP 450 from this protected endpoint means the session is
        // truly invalid/expired. Transient errors or a different hash must not
        // log the user out.
        if (error.response && error.response.status === 450) {
          dispatch({
            type: CHANGE_ERROR_MESSAGE,
            payload: "Your session has expired",
          });
          dispatch({
            type: CHANGE_ERROR_MESSAGE,
            payload: "",
          });
          // Drop the stale session keys, otherwise the login page thinks a
          // valid session still exists and never opens the connect modal.
          localStorage.removeItem("hash");
          localStorage.removeItem("username");
          localStorage.removeItem("expirationTime");
          localStorage.removeItem("affiliateId");
          dispatch(logout());
        }
      });
  };
}

export function updateClientEmail(clientEmail, id) {
  return (dispatch) => {
    dispatch(handleLoadState(true));
    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      updateTransactionEmail: "",
      hash: hashToken,
      clientEmail,
      urlUsed: currentUrl,
      transactionId: id,
    };

    const request = axios.post(
      "https://ppapi.instaswap.com/formData",
      payload
    );
    request
      .then((response) => {
        dispatch({
          type: UPDATE_CLIENT_EMAIL,
          payload: response.data.response,
        });
        setTimeout(() => {
          dispatch({
            type: UPDATE_CLIENT_EMAIL,
            payload: "",
          });
        }, 4000);
        dispatch(handleLoadState(false));
      })

      .catch((error) => {
        // Error handled
      });
  };
}


export function updateBps(bps) {
  return (dispatch) => {
    let hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    let payload = {
      updateBps: "",
      volume: bps,
      urlUsed: currentUrl,
      hash: hashToken
    };

    const request = axios.post(
      "https://ppapi.instaswap.com/formData",
      payload
    );

    request
      .then((response) => {
        dispatch({
          type: UPDATE_BPS,
          payload: bps
        });
      })
      .catch((error) => {
        console.error('Error updating bps:', error);
      });
  };
}

// ---- Sub-Partner Fees (legacy ppapi / formData) ----

// Backend may return numeric fields (partnerFeeBps, active) as strings → normalize.
function normalizeSubFee(raw) {
  if (!raw || typeof raw !== "object") return raw;
  const normalized = { ...raw };
  if (normalized.partnerFeeBps !== undefined) {
    normalized.partnerFeeBps = parseInt(normalized.partnerFeeBps, 10);
  }
  if (normalized.subAffiliateFeeBps !== undefined) {
    normalized.subAffiliateFeeBps = parseInt(normalized.subAffiliateFeeBps, 10);
  }
  if (normalized.active !== undefined) {
    normalized.active = parseInt(normalized.active, 10);
  }
  return normalized;
}

export function getSubFees() {
  return (dispatch) => {
    dispatch({ type: GET_SUB_FEES_LOADING, payload: true });
    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    const payload = {
      getSubFees: "",
      urlUsed: currentUrl,
      hash: hashToken,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => {
        dispatch({
          type: GET_SUB_FEES,
          payload: Array.isArray(response.data.response)
            ? response.data.response.map(normalizeSubFee)
            : [],
        });
      })
      .catch((error) => {
        console.error("Error fetching sub fees:", error);
        throw error;
      })
      .finally(() => {
        dispatch({ type: GET_SUB_FEES_LOADING, payload: false });
      });
  };
}

// Read-only reporting: accumulated fees accrued by the partner's sub-affiliates
// across completed swaps. Partner is identified from the session hash; only the
// caller's own sub-affiliates are returned by the backend.
export function getSubAffiliateFees({ from, to, subAffiliateId } = {}) {
  return (dispatch) => {
    dispatch({ type: GET_SUB_AFFILIATE_FEES_LOADING, payload: true });
    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    const payload = {
      getSubAffiliateFees: 1,
      urlUsed: currentUrl,
      hash: hashToken,
    };
    if (from) payload.from = from;
    if (to) payload.to = to;
    if (subAffiliateId) payload.subAffiliateId = subAffiliateId;

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => {
        dispatch({
          type: GET_SUB_AFFILIATE_FEES,
          payload: response.data.response || null,
        });
        return response.data.response;
      })
      .catch((error) => {
        console.error("Error fetching sub-affiliate fees:", error);
        throw error;
      })
      .finally(() => {
        dispatch({ type: GET_SUB_AFFILIATE_FEES_LOADING, payload: false });
      });
  };
}

// --- Partner API key management (session-hash auth, in-CMS only) ---

// Returns { hasKey, prefix, lastFour, createdAt, lastUsedAt } (no plaintext key).
export function getPartnerApiKeyMeta() {
  return () => {
    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;
    return axios
      .post("https://ppapi.instaswap.com/formData", {
        getPartnerApiKeyMeta: 1,
        urlUsed: currentUrl,
        hash: hashToken,
      })
      .then((response) => response.data.response || { hasKey: false });
  };
}

// Generate / regenerate. Returns the plaintext apiKey ONCE — never persist it.
export function generatePartnerApiKey() {
  return () => {
    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;
    return axios
      .post("https://ppapi.instaswap.com/formData", {
        generatePartnerApiKey: 1,
        urlUsed: currentUrl,
        hash: hashToken,
      })
      .then((response) => response.data.response);
  };
}

export function revokePartnerApiKey() {
  return () => {
    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;
    return axios
      .post("https://ppapi.instaswap.com/formData", {
        revokePartnerApiKey: 1,
        urlUsed: currentUrl,
        hash: hashToken,
      })
      .then((response) => response.data.response);
  };
}

export function createSubFee({ subLabel, partnerFeeBps, subAffiliateFeeBps }) {
  return (dispatch) => {
    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    const payload = {
      createSubFee: "",
      subLabel,
      partnerFeeBps,
      subAffiliateFeeBps,
      urlUsed: currentUrl,
      hash: hashToken,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => {
        const created = response.data.response;
        const row = normalizeSubFee({
          subLabel,
          partnerFeeBps,
          subAffiliateFeeBps,
          active: 1,
          ...(typeof created === "object" && created !== null ? created : {}),
        });
        dispatch({ type: CREATE_SUB_FEE, payload: row });
        return row;
      })
      .catch((error) => {
        console.error("Error creating sub fee:", error);
        throw error;
      });
  };
}

export function updateSubFee({ subAffiliateId, subLabel, partnerFeeBps, subAffiliateFeeBps, active }) {
  return (dispatch) => {
    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    const payload = {
      updateSubFee: "",
      subAffiliateId,
      urlUsed: currentUrl,
      hash: hashToken,
    };
    if (subLabel !== undefined) payload.subLabel = subLabel;
    if (partnerFeeBps !== undefined) payload.partnerFeeBps = partnerFeeBps;
    if (subAffiliateFeeBps !== undefined) payload.subAffiliateFeeBps = subAffiliateFeeBps;
    if (active !== undefined) payload.active = active;

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => {
        const updated = response.data.response;
        dispatch({
          type: UPDATE_SUB_FEE,
          payload: normalizeSubFee({
            subAffiliateId,
            ...(typeof updated === "object" && updated !== null ? updated : {}),
            ...(subLabel !== undefined ? { subLabel } : {}),
            ...(partnerFeeBps !== undefined ? { partnerFeeBps } : {}),
            ...(subAffiliateFeeBps !== undefined ? { subAffiliateFeeBps } : {}),
            ...(active !== undefined ? { active } : {}),
          }),
        });
        return updated;
      })
      .catch((error) => {
        console.error("Error updating sub fee:", error);
        throw error;
      });
  };
}

export function deleteSubFee(subAffiliateId) {
  return (dispatch) => {
    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    const payload = {
      deleteSubFee: "",
      subAffiliateId,
      urlUsed: currentUrl,
      hash: hashToken,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then(() => {
        dispatch({ type: DELETE_SUB_FEE, payload: subAffiliateId });
      })
      .catch((error) => {
        console.error("Error deleting sub fee:", error);
        throw error;
      });
  };
}

export function getQuotes(sumBalanceInUsd) {
  return async (dispatch) => {
    if (sumBalanceInUsd > 100) {
      try {
        const usdcQuote = await axios.get(`https://api.instaswap.com/v2/full/aggregator/quote?sellAsset=ETH.USDC-0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&buyAsset=ETH.ETH&slippage=3&sellAmount=${sumBalanceInUsd}`);

        const payload = {
          usdc: usdcQuote.data.response,
        };

        dispatch({
          type: GET_QUOTES,
          payload,
        });

        return payload; // Return the payload
      } catch (error) {
        console.error("Failed to fetch quotes", error);
      }
    }
  };
}

// ─── Webhook Management ───

const WALLETLESS_API = WALLETLESS_URL;

export function getWebhookConfig() {
  return (dispatch) => {
    const hashToken = localStorage.getItem('hash');
    const username = localStorage.getItem('username');

    return axios
      .get(`${WALLETLESS_API}/partner/webhook`, {
        headers: { 'X-Partner-Hash': hashToken, 'X-Partner-Username': username }
      })
      .then((response) => {
        dispatch({
          type: GET_WEBHOOK_CONFIG,
          payload: response.data || {},
        });
      })
      .catch((error) => {
        console.error('Error fetching webhook config:', error);
      });
  };
}

export function saveWebhookConfig({ webhookUrl, webhookEnabled, webhookDisplayFees }) {
  return (dispatch) => {
    const hashToken = localStorage.getItem('hash');
    const username = localStorage.getItem('username');

    return axios
      .post(`${WALLETLESS_API}/partner/webhook`, {
        hash: hashToken,
        username: username,
        webhookUrl: webhookUrl || '',
        webhookEnabled: webhookEnabled ? 1 : 0,
        webhookDisplayFees: webhookDisplayFees ? 1 : 0,
      })
      .then((response) => {
        const config = response.data || {};
        dispatch({
          type: SAVE_WEBHOOK_CONFIG,
          payload: config,
        });
        return config;
      })
      .catch((error) => {
        console.error('Error saving webhook config:', error);
        throw error;
      });
  };
}

export function testWebhook() {
  return () => {
    const hashToken = localStorage.getItem('hash');
    const username = localStorage.getItem('username');

    return axios
      .post(`${WALLETLESS_API}/partner/webhook/test`, {
        hash: hashToken,
        username: username,
      })
      .then((response) => {
        return response.data || { success: false };
      })
      .catch((error) => {
        console.error('Error testing webhook:', error);
        throw error;
      });
  };
}

/**
 * Fetch the authenticated partner's own wallet-change audit history.
 * Follows the ppapi /formData POST convention: action key = empty string,
 * session auth via `hash` from localStorage.
 *
 * Expected ppapi response shape (paginated):
 *   { response: { items: [...], total, page, itemsPerPage } }
 */
export function getOwnWalletAudit({ page = 1, itemsPerPage = 25 } = {}) {
  return (dispatch) => {
    dispatch({ type: GET_OWN_WALLET_AUDIT_LOADING, payload: true });

    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    const payload = {
      getOwnWalletAudit: "",
      hash: hashToken,
      urlUsed: currentUrl,
      page,
      itemsPerPage,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => {
        const raw = response.data?.response;
        // Support both paginated { items, total, page, itemsPerPage }
        // and legacy array shape, in case the endpoint rolls out gradually.
        const normalized = Array.isArray(raw)
          ? { items: raw, total: raw.length, page: 1, itemsPerPage: raw.length }
          : {
              items: Array.isArray(raw?.items) ? raw.items : [],
              total: Number(raw?.total) || 0,
              page: Number(raw?.page) || page,
              itemsPerPage: Number(raw?.itemsPerPage) || itemsPerPage,
            };
        dispatch({ type: GET_OWN_WALLET_AUDIT, payload: normalized });
        dispatch({ type: GET_OWN_WALLET_AUDIT_LOADING, payload: false });
        return normalized;
      })
      .catch((error) => {
        dispatch({ type: GET_OWN_WALLET_AUDIT_LOADING, payload: false });
        // Endpoint may not be live yet on ppapi; surface empty history
        // rather than breaking the page.
        dispatch({
          type: GET_OWN_WALLET_AUDIT,
          payload: { items: [], total: 0, page, itemsPerPage },
        });
        return { items: [], total: 0, page, itemsPerPage };
      });
  };
}

/**
 * User-initiated wallet relink (from the CMS "Update login wallet" CTA).
 * ppapi action `updatePartnerWallet` is NOT live yet — this is a stub
 * that posts the intended payload and returns the backend response so the
 * UI can either confirm or show the "coming soon" banner gracefully.
 */
export function updatePartnerWallet(newWalletAddress) {
  return (dispatch) => {
    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    const payload = {
      updatePartnerWallet: "",
      hash: hashToken,
      urlUsed: currentUrl,
      walletAddress: newWalletAddress,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => {
        dispatch({
          type: UPDATE_PARTNER_WALLET_SUCCESS,
          payload: response.data?.response,
        });
        return response.data?.response;
      })
      .catch((error) => {
        const backendMsg =
          error?.response?.data?.response ||
          error?.response?.data?.error ||
          error?.message;
        const err = new Error(backendMsg || "Failed to update login wallet");
        err.status = error?.response?.status;
        err.conflictingPartner = error?.response?.data?.conflictingPartner;
        throw err;
      });
  };
}

/**
 * Multi-wallet linking — list all wallets linked to the authenticated partner.
 * Expected response: { response: [{ wallet, source, linkedAt, isCanonical? }, ...] }
 */
export function listPartnerWallets() {
  return (dispatch) => {
    dispatch({ type: LIST_PARTNER_WALLETS_LOADING, payload: true });

    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    const payload = {
      listPartnerWallets: "",
      hash: hashToken,
      urlUsed: currentUrl,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => {
        const raw = response.data?.response;
        const items = Array.isArray(raw) ? raw : Array.isArray(raw?.items) ? raw.items : [];
        dispatch({ type: LIST_PARTNER_WALLETS, payload: items });
        dispatch({ type: LIST_PARTNER_WALLETS_LOADING, payload: false });
        return items;
      })
      .catch((error) => {
        dispatch({ type: LIST_PARTNER_WALLETS_LOADING, payload: false });
        dispatch({ type: LIST_PARTNER_WALLETS, payload: [] });
        return [];
      });
  };
}

/**
 * Multi-wallet linking — find wallets seen on other instaswap apps with the
 * same email but not yet linked to this partner. Used for the dashboard
 * "we detected another wallet" banner.
 * Expected response: { response: [{ wallet, source, lastSeen? }, ...] }
 */
export function findUnlinkedWalletsForEmail() {
  return (dispatch) => {
    dispatch({ type: FIND_UNLINKED_WALLETS_LOADING, payload: true });

    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    const payload = {
      findUnlinkedWalletsForEmail: "",
      hash: hashToken,
      urlUsed: currentUrl,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => {
        const raw = response.data?.response;
        const items = Array.isArray(raw) ? raw : Array.isArray(raw?.items) ? raw.items : [];
        dispatch({ type: FIND_UNLINKED_WALLETS, payload: items });
        dispatch({ type: FIND_UNLINKED_WALLETS_LOADING, payload: false });
        return items;
      })
      .catch((error) => {
        dispatch({ type: FIND_UNLINKED_WALLETS_LOADING, payload: false });
        dispatch({ type: FIND_UNLINKED_WALLETS, payload: [] });
        return [];
      });
  };
}

/**
 * Multi-wallet linking — link an additional wallet to the authenticated
 * partner. Source is one of 'manual' | 'banner' | 'website' | 'trade' etc.
 */
export function addPartnerWallet(walletAddress, source = "manual", twoFactorCode) {
  return (dispatch) => {
    const hashToken = localStorage.getItem("hash");

    // NOTE: the backend session-mode allowlist for addPartnerWallet accepts only
    // { addPartnerWallet, walletAddress, source, hash, twoFactorCode } — do NOT send urlUsed.
    const payload = {
      addPartnerWallet: "",
      hash: hashToken,
      walletAddress,
      source,
      twoFactorCode,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => response.data?.response)
      .catch((error) => {
        const backendMsg =
          error?.response?.data?.response ||
          error?.response?.data?.error ||
          error?.message;
        const err = new Error(backendMsg || "Failed to link wallet");
        err.status = error?.response?.status;
        err.conflictingPartner = error?.response?.data?.conflictingPartner;
        throw err;
      });
  };
}

/**
 * Multi-wallet linking — unlink a wallet from the authenticated partner.
 * Backend rejects (409) if the wallet matches sym_api_partners.walletAddress
 * (canonical identity wallet).
 */
export function removePartnerWallet(walletAddress) {
  return (dispatch) => {
    const hashToken = localStorage.getItem("hash");
    const currentUrl = window.location.href;

    const payload = {
      removePartnerWallet: "",
      hash: hashToken,
      urlUsed: currentUrl,
      walletAddress,
    };

    return axios
      .post("https://ppapi.instaswap.com/formData", payload)
      .then((response) => response.data?.response)
      .catch((error) => {
        const backendMsg =
          error?.response?.data?.response ||
          error?.response?.data?.error ||
          error?.message;
        const err = new Error(backendMsg || "Failed to unlink wallet");
        err.status = error?.response?.status;
        throw err;
      });
  };
}

/* ============================ Two-factor (TOTP) ============================ */

const PPAPI_URL = "https://ppapi.instaswap.com/formData";

function twoFactorError(error, fallback) {
  const backendMsg =
    error?.response?.data?.response ||
    error?.response?.data?.error ||
    error?.message;
  const err = new Error(backendMsg || fallback);
  err.status = error?.response?.status;
  return err;
}

/** Read the partner's own 2FA status. */
export function get2FAStatus() {
  return (dispatch) => {
    dispatch({ type: TWO_FACTOR_LOADING, payload: true });
    const hash = localStorage.getItem("hash");
    const urlUsed = window.location.href;
    return axios
      .post(PPAPI_URL, { get2FAStatus: "", hash, urlUsed })
      .then((res) => {
        const r = res.data?.response || {};
        dispatch({
          type: TWO_FACTOR_STATUS,
          payload: {
            enabled: !!r.enabled,
            loginRequired: !!r.loginRequired,
            enrolledAt: r.enrolledAt || null,
            loaded: true,
          },
        });
        dispatch({ type: TWO_FACTOR_LOADING, payload: false });
        return r;
      })
      .catch(() => {
        dispatch({ type: TWO_FACTOR_LOADING, payload: false });
        dispatch({
          type: TWO_FACTOR_STATUS,
          payload: { enabled: false, loginRequired: false, enrolledAt: null, loaded: true },
        });
        return null;
      });
  };
}

/** Begin enrollment: returns { secret, otpauthUri }. Pass current code to re-enroll. */
export function enroll2FA(twoFactorCode) {
  return () => {
    const hash = localStorage.getItem("hash");
    const urlUsed = window.location.href;
    const payload = { enroll2FA: "", hash, urlUsed };
    if (twoFactorCode) payload.twoFactorCode = twoFactorCode;
    return axios
      .post(PPAPI_URL, payload)
      .then((res) => res.data?.response)
      .catch((error) => {
        throw twoFactorError(error, "Failed to start 2FA setup");
      });
  };
}

/** Confirm enrollment with a code; enables 2FA. */
export function confirm2FA(twoFactorCode) {
  return (dispatch) => {
    const hash = localStorage.getItem("hash");
    const urlUsed = window.location.href;
    return axios
      .post(PPAPI_URL, { confirm2FA: "", hash, urlUsed, twoFactorCode })
      .then((res) => {
        dispatch(get2FAStatus());
        return res.data?.response;
      })
      .catch((error) => {
        throw twoFactorError(error, "Failed to confirm 2FA code");
      });
  };
}

/** Disable 2FA (requires the current code). */
export function disable2FA(twoFactorCode) {
  return (dispatch) => {
    const hash = localStorage.getItem("hash");
    const urlUsed = window.location.href;
    return axios
      .post(PPAPI_URL, { disable2FA: "", hash, urlUsed, twoFactorCode })
      .then((res) => {
        dispatch(get2FAStatus());
        return res.data?.response;
      })
      .catch((error) => {
        throw twoFactorError(error, "Failed to disable 2FA");
      });
  };
}

/** Toggle the "require 2FA at login" flag (requires the current code). */
export function set2FALoginRequired(value, twoFactorCode) {
  return (dispatch) => {
    const hash = localStorage.getItem("hash");
    const urlUsed = window.location.href;
    return axios
      .post(PPAPI_URL, {
        set2FALoginRequired: "",
        hash,
        urlUsed,
        value: value ? 1 : 0,
        twoFactorCode,
      })
      .then((res) => {
        dispatch(get2FAStatus());
        return res.data?.response;
      })
      .catch((error) => {
        throw twoFactorError(error, "Failed to update login 2FA setting");
      });
  };
}